var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { PositionCard } from '../../../../../../Hands/Report/PositionCard';
import { useCurrentTheme } from '../../../../../../hooks/useCurrentTheme';
import { sortedOrderPositionsFromObj } from '../../../../../../helpers/helpers';
import styles from './PreviewElements.module.scss';
import { Table } from 'antd';
import { CardTextBlock } from '../../../../../../components/cards/CardTextBlock';
import { RangesPositionsEV } from '../../../../../../Viewer/matrix/RangePositions/RangesPositions';
var cards = ['JhAh', '2c9h', '5d8c', '2sTs', '9hQs', '3dKc', 'TsQh', 'KhKs', 'Ad2c'];
var PreviewPositions = function (_a) {
    var type = _a.type;
    var theme = useCurrentTheme();
    var sortedPositions = sortedOrderPositionsFromObj(theme.positions);
    var tableData = useMemo(function () {
        var data = [];
        Object.entries(sortedPositions).map(function (_a, index) {
            var position = _a[0];
            data.push({
                position: position,
                spot: '9-max',
                hero: cards[index],
                line: 'FFCFR',
                flop: 'QcQdQh',
            });
        });
        return data;
    }, []);
    var renderCols = useMemo(function () {
        var cols = [];
        cols.push({
            title: 'Spot',
            dataIndex: 'spot',
            key: 'spot',
        }, {
            title: 'Hero',
            dataIndex: 'hero',
            key: 'hero',
            width: 60,
            render: function (cards) { return (_jsx("div", __assign({ style: { height: '22px', width: '60px' } }, { children: _jsx(CardTextBlock, { cards: cards, isSquare: true, isFullWidth: true }) }))); },
        }, {
            title: 'Pos.',
            dataIndex: 'position',
            key: 'position',
            render: function (position) { return (_jsx("div", __assign({ style: { height: '22px' } }, { children: _jsx(RangesPositionsEV, { player: position }) }))); },
        }, {
            title: 'Line',
            dataIndex: 'line',
            key: 'line',
            width: 65,
        }, {
            title: 'Flop',
            dataIndex: 'flop',
            key: 'flop',
            width: 90,
            render: function (cards) { return (_jsx("div", __assign({ style: { height: '22px' } }, { children: _jsx(CardTextBlock, { cards: cards, isSquare: true, isFullWidth: true }) }))); },
        });
        return cols;
    }, []);
    return (_jsxs("div", __assign({ className: styles.positionsPreview }, { children: [_jsx("div", { children: Object.entries(sortedPositions).map(function (_a, index) {
                    var position = _a[0];
                    return (_jsx(PositionCard, { position: position }, index));
                }) }), _jsx("div", { children: type === 'positions' ? (_jsx(Table, { pagination: false, size: 'small', columns: renderCols, dataSource: tableData, className: styles.antdTable })) : null })] })));
};
export default PreviewPositions;
